import { styled as a, Box as e, shippoTheme as t, List as i, ListItemIcon as s, colors as n, MenuItem as r, Typography as c } from "@goshippo/components";
const p = a(e)`
  margin-bottom: ${t.spacing(2)};
`, u = a(e)`
  padding: ${t.spacing(1, 0)};
  display: flex;
  align-items: center;
  gap: ${t.spacing(1)};
  justify-content: start;

  ${t.breakpoints.up("lg")} {
    gap: ${t.spacing(2)};
  }
`, d = a(i)`
  ${t.breakpoints.up("lg")} {
    margin-left: ${t.spacing(4)};
  }
`, l = a(s)`
  justify-content: 'center';
  min-width: auto;
  color: ${n.secondary};
`, m = a(r, {
  shouldForwardProp: (o) => o !== "isCurrentRoute"
})`
  min-height: auto;
  padding: ${t.spacing(1)};
  border-radius: ${t.spacing(1, 0, 0, 1)};
  background-color: ${(o) => o.isCurrentRoute ? n.accent.background.success : "transparent"};
`, y = a(c)`
  white-space: break-spaces;
  color: ${n.text.default};
`;
export {
  p as NavigationCategory,
  l as NavigationCategoryIcon,
  d as NavigationCategoryItems,
  u as NavigationCategoryTitle,
  m as NavigationMenuItem,
  y as NavigationMenuTypography
};
//# sourceMappingURL=Navigation.styled.js.map
